import { spreadRowGapMm } from "./sheet-geometry.js";
/**
 * O selo de garantia da Elite Digital, pronto (F140).
 *
 * É a folha que o dono fotografou saindo do GDOOR — A4, 4 × 10, adesivo de
 * 39 × 24 mm — e que nenhum dos seis `.conf` exportados reproduz: o `ETIQUETAS
 * TONY 2024` escreve "ELITE (T.N)" e uma garantia de três itens; o `WEFIX`
 * escreve "Elite Digital (Wefix)" em cinza. A foto tem, de cima para baixo:
 * a descrição em negrito; o código, o nome da loja em vermelho e a data; o
 * código de barras; a garantia em azul; "NÃO REMOVER ESSA ETIQUETA".
 *
 * As medidas da folha são as do TONY e do WEFIX, os dois 4 × 10 que a loja
 * usa; o vão entre fileiras é o que espalha as dez pela A4 como o GDOOR faz.
 * Criado a partir daqui, o modelo é um modelo como outro qualquer: abre no
 * editor e se ajusta lá.
 */
export const WARRANTY_SEAL_NAME = 'Selo garantia 4×10';
const text = (element) => ({
    kind: 'text',
    text: '',
    fontFamily: 'Arial',
    color: '#000000',
    background: null,
    bold: false,
    italic: false,
    underline: false,
    align: 'left',
    wrap: false,
    rotationDeg: 0,
    ...element,
});
const PAGE = {
    widthMm: 210,
    heightMm: 297,
    marginLeftMm: 7.7,
    marginTopMm: 5.5,
    marginRightMm: 0,
    marginBottomMm: 0,
};
const LABEL = { widthMm: 39, heightMm: 24 };
const ROWS = 10;
export const warrantySealLayout = (companyName) => ({
    name: WARRANTY_SEAL_NAME,
    page: PAGE,
    label: LABEL,
    columns: 4,
    rows: ROWS,
    columnGapMm: 5.7,
    rowGapMm: spreadRowGapMm({
        pageHeightMm: PAGE.heightMm,
        marginTopMm: PAGE.marginTopMm,
        marginBottomMm: PAGE.marginBottomMm,
        labelHeightMm: LABEL.heightMm,
        rows: ROWS,
    }),
    elements: [
        text({
            source: 'name',
            leftMm: 1,
            topMm: 0.8,
            widthMm: 37,
            heightMm: 6.6,
            fontSizePt: 7,
            bold: true,
            align: 'center',
            wrap: true,
            color: '#000000',
        }),
        text({
            source: 'sku',
            leftMm: 1,
            topMm: 7.6,
            widthMm: 12,
            heightMm: 3.4,
            fontSizePt: 6.5,
            color: '#000000',
        }),
        text({
            source: 'literal',
            text: companyName.trim() === '' ? 'Aeris One' : companyName.trim(),
            leftMm: 8,
            topMm: 7.6,
            widthMm: 23,
            heightMm: 3.4,
            fontSizePt: 6,
            bold: true,
            align: 'center',
            color: '#000000',
        }),
        text({
            source: 'printedAt',
            leftMm: 24,
            topMm: 7.6,
            widthMm: 14,
            heightMm: 3.4,
            fontSizePt: 6.5,
            align: 'right',
            color: '#000000',
        }),
        {
            kind: 'barcode',
            leftMm: 2,
            topMm: 11,
            widthMm: 35,
            heightMm: 5.6,
            moduleWidth: 2,
            showText: false,
            color: '#000000',
        },
        text({
            source: 'literal',
            text: 'GARANTIA NÃO COBRE: ARRANHADO,\nQUEBRADO, MOLHADO, PRESSÃO, RASGADO E MAL USO.',
            leftMm: 0.5,
            topMm: 17.1,
            widthMm: 38,
            heightMm: 4.2,
            fontSizePt: 4.5,
            bold: true,
            align: 'center',
            color: '#000000',
        }),
        text({
            source: 'literal',
            text: 'NÃO REMOVER ESSA ETIQUETA',
            leftMm: 1,
            topMm: 21.1,
            widthMm: 37,
            heightMm: 2.6,
            fontSizePt: 5,
            bold: true,
            align: 'center',
            color: '#000000',
        }),
    ],
});
//# sourceMappingURL=label-presets.js.map